// Lib
import { Action, handleActions } from 'redux-actions';
import { CSSProperties, ReactNode } from 'react';

// Actions
import { ClosePopup, OpenPopup } from '@actions/popup';

interface PopupState {
  display: boolean;
  title: string | null;
  children: ReactNode | null;
  onCancel: (() => void) | null;
  onDone: (() => void) | null;
  style: CSSProperties | null;
  id: string | null;
  animation: string | null;
  positiveText: string;
  negativeText: string;
  closable: boolean;
  top: number;
  isMobileFullSize: boolean;
  isTheme: boolean;
}

interface OpenPopupPayload {
  title?: string;
  children?: ReactNode;
  onCancel?: () => void;
  onDone?: () => void;
  style?: CSSProperties;
  id?: string;
  animation?: string;
  positiveText?: string;
  negativeText?: string;
  closable?: boolean;
  top?: number;
  isMobileFullSize?: boolean;
  isTheme?: boolean;
}

type OpenPopupAction = Action<OpenPopupPayload>;

const initialState: PopupState = {
  display: false,
  title: null,
  children: null,
  onCancel: null,
  onDone: null,
  style: null,
  id: null,
  animation: null,
  positiveText: 'Yes',
  negativeText: 'No',
  closable: true,
  top: 0,
  isMobileFullSize: false,
  isTheme: false,
};

export default handleActions<PopupState, OpenPopupPayload | void>(
  {
    [OpenPopup.toString()]: (
      _: PopupState,
      { payload }: OpenPopupAction,
    ): PopupState => ({
      ...initialState,
      display: true,
      ...payload,
    }),
    [ClosePopup.toString()]: (): PopupState => initialState,
  },
  initialState,
);
